<div class="px-3 py-2">
	<h4 align="center">MaGIC 2026 - Marche Workshop on Group Actions in Cryptography</h4>
	<p><a href="https://magic-workshop.github.io/" target="_blank">magic-workshop.github.io</a></p>

	<p>
		<b>MaGIC 2026</b> is a workshop dedicated to the study of <b>cryptographic group actions</b>, a
		rapidly evolving area at the intersection of algebraic geometry, number theory, and
		<b>post-quantum cryptography</b>. The workshop will bring together researchers working in
		isogeny-based and code-based cryptography, spanning theoretical foundations and
		practical applications of group-action techniques.
	</p>

	<p>
		The event will take place in the beautiful setting of <b>Borgo Lanciano</b>, a historic venue
		in the Marche region of Italy, providing an ideal environment for scientific exchange
		and collaboration.
	</p>
</div>